import React from 'react'
import PropTypes from 'prop-types'
import _map from 'lodash/map'

// PropTypes
import {
  columns as columnsPropTypes,
  maybeFunction,
} from './propTypes'

// Components
import ColumnHeader from './ColumnHeader'
import checked from './Checked'
import unchecked from './Unchecked'

// Styles
import {
  headerStyle,
  checkboxStyle,
  dataRowStyle,
} from './styles'

// Exports
export const TableHeader = ({
  asc,
  columns,
  allSelected,
  onSelectAll,
  onSort,
  sortedBy,
  smallScreen,
  canSelectAll,
  hideSelectAll,
  hideSorters,
}) => (
  <div data-test='TableHeader' style={headerStyle}>
    {!hideSelectAll ? typeof onSelectAll === 'function' ? (
      <div style={checkboxStyle} onClick={onSelectAll}>
        <div>{canSelectAll ? (allSelected ? checked : unchecked) : (null)}</div>
      </div>
    ) : null : <div style={{
      width: '40px',
    }} />}
    <div style={dataRowStyle}>
      {_map(columns, (column, index) => (
        <ColumnHeader
          key={index}
          {...column}
          onSort={typeof onSort === 'function' ? function () {
            onSort({
              attr: column.attr,
              sortAs: column.sortAs,
              booleanAttr: column.booleanAttr,
              groupBy: column.groupBy,
              groupOrder: column.groupOrder,
            })
          } : undefined}
          sortedBy={column.attr === sortedBy}
          asc={asc}
          smallScreen={smallScreen}
          hideSorters={column.hideSorters || hideSorters}
        >
          {typeof column.render === 'function' ? column.render(column): column.attr}
        </ColumnHeader>
      ))}
    </div>
  </div>
)

// old table header code
// {column.attr}

TableHeader.propTypes = {
  columns: columnsPropTypes,
  onSelectAll: maybeFunction,
  allSelected: PropTypes.bool.isRequired,
  onSort: maybeFunction,
  sortedBy: PropTypes.string,
  asc: PropTypes.bool,
  canSelectAll: PropTypes.bool,
  smallScreen: PropTypes.bool,
  hideSelectAll: PropTypes.bool,
  hideSorters: PropTypes.bool,
}

export default TableHeader
